import React from 'react';
import styled, { css } from 'styled-components';
import TinyColor from 'tinycolor2';

import { PreviewTheme } from '../preview.types';

type AddtoCartProps = {
  theme: PreviewTheme;
  isTinted?: boolean;
  isFullWidth?: boolean;
};

export const AddToCart = ({ theme, isTinted = true, isFullWidth = true }: AddtoCartProps): JSX.Element => (
  <Button type='button' theme={theme} $isTinted={isTinted} $isFullWidth={isFullWidth}>
    Add to cart
  </Button>
);

const tintedButtonStyles = css`
  /* Hex alpha 10% */
  background: ${({ theme }) => theme.linkColor}1A;
  color: ${({ theme }) => TinyColor.mix(theme.linkColor, '#000', 20).toString()};
`;

const solidButtonStyles = css`
  background: ${({ theme }) => theme.linkColor};
  color: #fff;
`;

const solidButtonHoverStyles = css`
  background: ${({ theme }) => TinyColor.mix(theme.linkColor, '#000', 20).toString()};
  color: #fff;
`;

const Button = styled.button<{ $isTinted: boolean; $isFullWidth: boolean }>`
  appearance: none;
  border: none;
  border-radius: ${({ theme }) => theme.radius.buttons};
  cursor: pointer;
  display: block;
  font-weight: bold;
  padding: 10px 12px;
  text-transform: ${({ theme }) => theme.textTransforms.buttons};
  width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : 'auto')};

  ${({ $isTinted }) => ($isTinted ? tintedButtonStyles : solidButtonStyles)}

  &:hover {
    ${({ $isTinted }) => ($isTinted ? solidButtonStyles : solidButtonHoverStyles)}
  }
`;
